import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import GlobalContext, { useHasOwnerReviews } from '~/context/vdp/GlobalContext';
import {
  useGetSpinnerData,
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import useGetOEMData from '~/hooks/vdp/selectors/useGetOEMData';

export default function useSendContentAvailability(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    hasOwnerReviews: { isLoaded: hasOwnerReviewsLoaded },
    vehicleRating: { isLoaded: hasVehicleRatingLoaded }
  } = useContext(GlobalContext);
  const isLoaded = hasOwnerReviewsLoaded || hasVehicleRatingLoaded;
  const hasOwnerReviews = useHasOwnerReviews();
  const { showOEMData } = useGetOEMData();
  const { brochureUrl, windowStickerUrl } = useGetVehicleDetails();
  const { imperfections = [] } = useGetSpinnerData();

  const imperfectionCount = imperfections.length;

  useEffectOnce(
    () => {
      trackEvent('content-availability', {
        hasBrochure: Boolean(brochureUrl),
        hasOemData: showOEMData,
        hasOwnerReviews,
        hasWindowSticker: Boolean(windowStickerUrl),
        imperfectionCount
      });
    },
    [
      brochureUrl,
      hasOwnerReviews,
      imperfectionCount,
      isLoaded,
      showOEMData,
      trackEvent,
      windowStickerUrl
    ],
    isLoaded
  );
}
